import axios from 'axios'

// URL base dell'API per le iniziative, recuperato dall'env file

const INIZIATIVA_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'iniziativa'

const headers = { 'Content-Type': 'application/json' }

class IniziativaService {
    /**
     * Recupera tutti le iniziative disponibili nel sistema.
     * Effettua una richiesta GET a `/iniziativa/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutte le iniziative.
     */
    getAll() {
        return axios.get(INIZIATIVA_REST_API_URL + "/all");
    }

    /**
     * Recupera tuttle iniziative associati a un determinato comune, con i progetti ad essa associati
     * Effettua una richiesta GET a `/iniziativa/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare le iniziative.
     * @returns {Promise} - Una promessa che restituisce la lista delle iniziative del comune specificato.
     */
    getAllByComune(comId) {
        return axios.get(INIZIATIVA_REST_API_URL + "/comune/" + comId);
    }

    /**
     * Recupera un iniziativa specifico in base al suo ID, e tutti i progetti ad essa associati
     * Effettua una richiesta GET a `/iniziativa/{iniId}`.
     *
     * @param {number} iniId - L'ID dell'iniziativa da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli dell'iniziativa.
     */    
    getIniziativa(iniId) {
        return axios.get(INIZIATIVA_REST_API_URL + `/${iniId}`)
    }

    /**
     * Recupera tuttle iniziative associati a un determinato comune senza i progetti associati
     * Effettua una richiesta GET a `/iniziativa/comune/{comId}/with-fasi`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare le iniziative.
     * @returns {Promise} - Una promessa che restituisce la lista delle iniziative del comune specificato.
     */    
    getIniziativaWithoutProjects(comId) {
        return axios.get(INIZIATIVA_REST_API_URL +  "/comune/" + `${comId}` + "/with-fasi")
    }

    /**
     * Salva o aggiorna un iniziativa nel sistema.
     * Effettua una richiesta POST a `/iniziativa/save` con i dati dell'iniziativa.
     *
     * @param {Object} iniziativa - Oggetto contenente i dettagli dell'iniziativa da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveIniziativa(iniziativa) {
        return axios.post(INIZIATIVA_REST_API_URL + "/save", iniziativa, headers)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const iniziativaServiceInstance = new IniziativaService();
export default iniziativaServiceInstance;